import { createElement } from 'react'
import QuestionKey from './question-key'
import QuestionList from './question-list'
import { AppFormEventParams } from '../services/events-service'

const getQuestion = (
  key: QuestionKey,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  existingAnswers: any,
  questionIndex: number,
  returningViaPrevious: boolean,
  errors?: { [key: string]: boolean },
  bouncerError?: string,
  eventsServiceUrl?: string,
  appFormEventParams?: AppFormEventParams
) =>
  createElement(QuestionList[key], {
    existingAnswers,
    disablePrevious: questionIndex === 0,
    questionKey: key,
    returningViaPrevious,
    errors,
    bouncerError,
    eventsServiceUrl,
    appFormEventParams
  })

export default {
  getQuestion
}
